import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import s from './Editor.sass';

const defaultModules = {
    toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'image', 'video'],
        ['clean']
    ]
};

const defaultFormats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'align',
    'list', 'bullet',
    'link', 'image', 'video'
];

const Editor = ({ editorRef, textFromAPI, modules = defaultModules, formats = defaultFormats, placeholder }) => {
    const [value, setValue] = useState('');

    useEffect(() => {
        if (textFromAPI) {
            setValue(textFromAPI);
        }
    }, [textFromAPI]);

    useEffect(() => {
        if (editorRef) {
            editorRef.current = value;
        }
    }, [value, editorRef]);

    return (
        <ReactQuill
            placeholder={placeholder || ''}
            className={s.customQuill}
            value={value}
            onChange={setValue}
            modules={modules}
            formats={formats}
        />
    );
};

export default Editor;
